import * as fromDatatype from '../../../../../models/datatype-library';

export class PmtStmtPeppolLinkDto {
    guid: fromDatatype.GuidDataFieldInterface;
    supplier_name: fromDatatype.VarcharDatatypeInterface;
    original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
    einvoice_datetime: fromDatatype.TimestampTzDatatypeInterface;
    validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
    irb_doc_unique_ref_no: fromDatatype.VarcharDatatypeInterface;
    total_include_tax: fromDatatype.NumericDatatypeInterface;
  }
  